import React, { createContext, useContext, useState, useEffect } from "react";
import { translations } from "./translations";

const LanguageContext = createContext({ lang: "de", setLang: () => {}, t: translations.de });

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("em_lang") || "de");

  useEffect(() => {
    localStorage.setItem("em_lang", lang);
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const value = { lang, setLang, t: translations[lang] };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);
